"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var DecoderResponseSuccess = function () {
  function e(e) {
    e.codeId && (this.codeId = e.codeId), e.codeSet && (this.codeSet = e.codeSet), e.probability && (this.probability = e.probability), e.debugInfo && (this.debugInfo = e.debugInfo), e.direction && (this.direction = e.direction), this.rawData = e;
  }

  return e.prototype.description = function () {
    return "codeId: " + this.codeId + ", codeSet: " + this.codeSet + ", probability: " + this.probability + ", direction: " + this.direction;
  }, e;
}();

exports.DecoderResponseSuccess = DecoderResponseSuccess;